import { suppliers } from "@/api";
import axios from "axios";

/* eslint no-param-reassign: ["error"] */
const currentState = {
  invoices: [],
  canBeInvoiced: [],
  onNextInvoice: [],
  nextInvoiceDate: null,
  nextExpiryDate: null,
  currentInvoiceSum: null,
  nextInvoiceSum: null,
  selected: [],
};

const mutations = {
  add_invoices(state, invoices) {
    state.invoices = invoices;
  },
  set_can_be_invoiced(state, invoiceDetails) {
    state.canBeInvoiced = invoiceDetails;
  },
  add_on_next_invoice(state, invoiceDetails) {
    state.onNextInvoice = invoiceDetails;
  },
  set_next_invoice_date(state, date) {
    state.nextInvoiceDate = date;
  },
  set_next_expiry_date(state, date) {
    state.nextExpiryDate = date;
  },
  set_selected(state, items) {
    state.selected = items;
  },
  set_current_invoice_sum(state, sum) {
    state.currentInvoiceSum = sum;
  },
  set_next_invoice_sum(state, sum) {
    state.nextInvoiceSum = sum;
  },
};

const actions = {
  async getInvoices({ commit, rootState }) {
    try {
      const { data } = await suppliers.invoices(
        rootState.auth.user.supplier.id
      );
      commit("add_invoices", data.invoices);
      commit("set_can_be_invoiced", data.canBeInvoiced);
      commit("add_on_next_invoice", data.onNextInvoice);
      commit("set_next_invoice_date", data.nextInvoiceDate);
      commit("set_next_expiry_date", data.nextExpiryDate);
      commit("set_current_invoice_sum", data.currentInvoiceSum);
      commit("set_next_invoice_sum", data.nextInvoiceSum);
    } catch (error) {
      console.log(error);
    }
  },
  async addToInvoice({ getters, dispatch }) {
    try {
      const { data } = await suppliers.addToInvoice({
        invoice_detail_ids: getters.selected.map((selected) => selected.id),
      });
      dispatch("getInvoices");

      return data;
    } catch (error) {
      console.log(error);
    }

    return [];
  },
};

const getters = {
  invoices: (state) => state.invoices,
  nextExpiryDate: (state) => state.nextExpiryDate,
  nextInvoiceDate: (state) => state.nextInvoiceDate,
  selected: (state) => state.selected,
  currentInvoiceSum: (state) => state.currentInvoiceSum,
  nextInvoiceSum: (state) => state.nextInvoiceSum,
  invoiceTable: (state) =>
    state.invoices.map((invoice) => ({
      id: invoice.id,
      status: invoice.paid_at ? "Utbetalt" : "Ikke utbetalt",
      dato: invoice.created_at,
      total: invoice.transaction_sum,
      download: invoice.id,
      is_manual: invoice.is_manual
    })),
  nextInvoiceTable: (state) =>
    state.onNextInvoice.map((invoiceDetail) => ({
      verdibevis: invoiceDetail.code,
      navn: invoiceDetail.product_name,
      total:
        invoiceDetail.price === 0
          ? -invoiceDetail.commission
          : (invoiceDetail.price.amount) /
            100,
      dato: invoiceDetail.created_at,
    })),
  canBeInvoicedTable: (state) =>
    state.canBeInvoiced.map((invoiceDetail) => ({
      id: invoiceDetail.id,
      verdibevis: invoiceDetail.code,
      navn: invoiceDetail.product_name,
      total:
        invoiceDetail.price === 0
          ? -invoiceDetail.commission
          : (invoiceDetail.price.amount) /
            100,
      dato: invoiceDetail.created_at,
    })),
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
